import gui from '@/webgl/dev/gui'

export const BASE_SETTINGS = {
  MIN_SPEED: 2.8,
  MAX_SPEED: 5,
}

export class SettingsEntity {
  LANE_SIZE: number = 0.5
  LANE_LENGTH: number = 10
  LANE_COUNT: number = 3

  WRONG_INCR_AMOUNT: number = 0.2
  MISS_INCR_AMOUNT: number = 0.1
  GOOD_DECR_AMOUNT: number = 0.1
  OBSTACLE_INCR_AMOUNT: number = 0.85

  GRAB_THRESHOLD: number = -2.5
  MISS_THRESHOLD: number = -2

  scrollSpeed: number = 0
  minSpeed: number = BASE_SETTINGS.MIN_SPEED
  maxSpeed: number = BASE_SETTINGS.MAX_SPEED

  /// #if _DEBUG
  constructor() {
    const fld = gui.folder('Settings')
    fld.add(this, 'LANE_LENGTH', { min: 0, max: 20 })
    fld.add(this, 'LANE_SIZE', { min: 0, max: 1 })
  }
  /// #endif
}
